import { OptimizerPanel } from "../components/admin/OptimizerPanel";

export default function AdminOptimizer(): JSX.Element {
  return (
    <div>
      <OptimizerPanel />
    </div>
  );
}
